export function formatDate(value?: string | null) {
  if (!value) return "";
  const iso = value.length <= 10 ? `${value}T12:00:00` : value;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
}

export function formatShortDate(value?: string | null) {
  if (!value) return "";
  const iso = value.length <= 10 ? `${value}T12:00:00` : value;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function youtubeEmbed(url?: string | null) {
  if (!url) return null;
  const match = url.match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([A-Za-z0-9_-]{6,})/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

export function youtubeThumb(url?: string | null) {
  const embed = youtubeEmbed(url);
  if (!embed) return null;
  const id = embed.split("/").pop();
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
}

/** Extrai o código de um post/reel do Instagram e devolve a URL de embed. */
export function instagramEmbed(url?: string | null) {
  if (!url) return null;
  const match = url.match(/instagram\.com\/(?:[A-Za-z0-9_.]+\/)?(?:p|reel|reels|tv)\/([A-Za-z0-9_-]+)/);
  return match ? `https://www.instagram.com/p/${match[1]}/embed/captioned` : null;
}

export type VideoEmbed = { provider: "instagram" | "youtube"; src: string };

/** Detecta a plataforma a partir do link colado no painel. */
export function videoEmbed(url?: string | null): VideoEmbed | null {
  const ig = instagramEmbed(url);
  if (ig) return { provider: "instagram", src: ig };
  const yt = youtubeEmbed(url);
  if (yt) return { provider: "youtube", src: yt };
  return null;
}
